import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { usePage } from '@inertiajs/react';
import { useTheme } from '@/hooks/use-theme';
function loadScript(src, id) {
    return new Promise((resolve, reject) => {
        if (document.getElementById(id)) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.id = id;
        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Falha ao carregar ${src}`));
        document.head.appendChild(script);
    });
}
/**
 * Mesmo fingerprint das telas antigas (ThumbmarkJS): preenche fp/fpId e
 * grava o cookie rp_access_fp usado pelo bloqueio de acesso.
 */
export function useFingerprint() {
    const [fp, setFp] = React.useState({ fp: '', fpId: '' });
    React.useEffect(() => {
        let cancelled = false;
        loadScript('https://cdn.jsdelivr.net/npm/@thumbmarkjs/thumbmarkjs/dist/thumbmark.umd.js', 'thumbmarkjs')
            .then(() => {
            const lib = window.ThumbmarkJS;
            if (!lib)
                return;
            return Promise.all([lib.getFingerprint(), lib.getFingerprintData()]).then(([id, data]) => {
                if (cancelled)
                    return;
                document.cookie = `rp_access_fp=${encodeURIComponent(id)}; path=/; max-age=31536000; SameSite=Lax`;
                setFp({ fpId: id, fp: btoa(unescape(encodeURIComponent(JSON.stringify(data, null, 2)))) });
            });
        })
            .catch(() => undefined);
        return () => {
            cancelled = true;
        };
    }, []);
    return fp;
}
/** Widget do Cloudflare Turnstile. Sem chave configurada, não aparece e a tela segue liberada. */
export function Turnstile({ onVerify }) {
    const { app } = usePage().props;
    const { resolved } = useTheme();
    const siteKey = app.turnstileSiteKey;
    const ref = React.useRef(null);
    const widgetId = React.useRef(null);
    React.useEffect(() => {
        if (!siteKey) {
            onVerify('disabled');
            return;
        }
        let cancelled = false;
        loadScript('https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit', 'cf-turnstile')
            .then(() => {
            const wait = () => {
                const turnstile = window.turnstile;
                if (cancelled || !ref.current)
                    return;
                if (!turnstile) {
                    window.setTimeout(wait, 100);
                    return;
                }
                widgetId.current = turnstile.render(ref.current, {
                    sitekey: siteKey,
                    theme: resolved,
                    language: 'pt-br',
                    size: 'flexible',
                    callback: (token) => onVerify(token),
                    'expired-callback': () => onVerify(null),
                    'error-callback': () => onVerify(null),
                });
            };
            wait();
        })
            .catch(() => onVerify(null));
        return () => {
            cancelled = true;
            const turnstile = window.turnstile;
            if (turnstile && widgetId.current)
                turnstile.remove(widgetId.current);
        };
    }, [siteKey, resolved]);
    if (!siteKey)
        return null;
    return _jsx("div", { ref: ref, className: "min-h-[65px] w-full" });
}
